/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import FinalPayorDiscount from './FinalPayorDiscount/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import MaxDiscount from './MaxDiscount/index'
import PaymentPlanDiscount from './PaymentPlanDiscount/index'
import PaymentPlanSetup from './PaymentPlanSetup/index'
import PayorDiscount from './PayorDiscount/index'
import PayorShare from './PayorShare/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import RemainingMaxDiscount from './RemainingMaxDiscount/index'
import TotalDiscount from './TotalDiscount/index'
import TreatmentDiscount from './TreatmentDiscount/index'
import Tysiav2InfoFilled from 'DesignSystem/Svgs/Tysiav2InfoFilled/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Info({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans/PaymentPlans/Content/PaymentPlan/Info"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnHover={true}
 offsetMainAxis={-20}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="Info.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-a3J8': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2InfoFilled
  viewPath={`${viewPath}/Tysiav2InfoFilled`}
 width={13}
 height={13}
 fill2={dtColorsNeutral400}
/>
</div>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<div
  data-testid="Info.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-2-a3J8': dtColorsWhite,'--bc-3-a3J8': dtColorsNeutral200,'--btlr-4-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-6-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-7-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-1-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-8-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-9-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-10-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-11-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block new-shadow ${styles.Vertical1}`}
>
<PaymentPlanSetup
  viewPath={`${viewPath}/PaymentPlanSetup`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<PayorShare
  viewPath={`${viewPath}/PayorShare`}
/>
<PayorDiscount
  viewPath={`${viewPath}/PayorDiscount`}
/>
<PaymentPlanDiscount
  viewPath={`${viewPath}/PaymentPlanDiscount`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<TotalDiscount
  viewPath={`${viewPath}/TotalDiscount`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<MaxDiscount
  viewPath={`${viewPath}/MaxDiscount`}
/>
<TreatmentDiscount
  viewPath={`${viewPath}/TreatmentDiscount`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<RemainingMaxDiscount
  viewPath={`${viewPath}/RemainingMaxDiscount`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<FinalPayorDiscount
  viewPath={`${viewPath}/FinalPayorDiscount`}
/>
</div>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}